export default "__VITE_PUBLIC_ASSET__31d20fe5__"